import React from 'react'
import RoomsSuggestionsModal from 'frontend/schedule/rooms-suggestions-modal'
import ActionModal from 'frontend/components/action-modal'
import CommonIcons from 'frontend/components/common-icons'

export default class AddAnotherGameModal extends RoomsSuggestionsModal {
  renderTitle () {
    if (this.state.suggestions) {
      return <span>Available rooms in {this.state.suggestions.name}</span>
    }

    return null
  }

  renderSuggestions () {
    const { time, location, onClose } = this.props
    const schedulePath =
      `/los-angeles/schedule?selectedFilterLocationId=${location.id}&selectedDate=${time.format('YYYY-MM-DD')}`
    return (
      <div>
        {super.renderSuggestions()}
        <div className="links_place">
          <button className="return_button" onClick={onClose}>
            <CommonIcons item="common-angle-left" className="icon" width={16} height={16} />
            <span>Return</span>
          </button>

          <a className="link_to_full_schedule" href={schedulePath}>
            Full schedule
            <CommonIcons item="common-angle-right" className="icon" width={16} height={16} />
          </a>
        </div>
      </div>
    )
  }

  render () {
    return (
      <ActionModal
        title={this.renderTitle()}
        body={this.renderSuggestions()}
        onClose={this.props.onClose}
        isOpen={this.props.isOpen}
        className="add_another_game_modal"
      />
    )
  }
}
